import PropTypes from 'prop-types';
import React from 'react';
export var ProfileViewRow = function ProfileViewRow(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "row my-2 gap-y-2"
  }, children);
};
ProfileViewRow.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=ProfileViewRow.js.map